import Photo1 from "../../../assets/slider/slider-1.jpg";
import Photo2 from "../../../assets/slider/slider-2.jpg";
import Photo3 from "../../../assets/slider/slider-3.jpg";
import Photo4 from "../../../assets/slider/slider-4.jpg";
import Photo5 from "../../../assets/slider/slider-5.jpg";
import Photo6 from "../../../assets/slider/slider-6.jpg";
import Photo7 from "../../../assets/slider/slider-7.jpg";

export const Photos = [Photo1, Photo2, Photo3, Photo4, Photo5, Photo6, Photo7];
